/* eslint-disable react/no-unescaped-entities */
// components/ErrorBoundary.tsx
import React from 'react'
import './ErrorFallback.css'
import { postDataService } from './services/back-end-service'
import { url } from './services/path-url'
import { onError } from './utils/CommonMethods'
import { LoaderWhiteBtn } from './components/Loader/LoaderWhiteBtn'
import Package from '../package.json'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      isLoading: false,
      isPosted: false,
    }
    this.errorReported = false
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  serializeError = (err) => ({
    message: err?.message,
    name: err?.name,
    stack: err?.stack,
    componentStack: err?.componentStack,
  })

  postError(params) {
    if (this.errorReported) return
    this.errorReported = true
    this.setState({ isLoading: true })
    try {
      postDataService(
        params,
        `${url.auth.send_error_info}`,
        () => {
          this.setState({ isPosted: true, isLoading: false })
        },
        (error) => {
          this.setState({ isPosted: false, isLoading: false })
          onError(error)
        }
      )
    } catch (error) {
      this.setState({ isPosted: false, isLoading: false })
    }
  }

  componentDidCatch(error, errorInfo) {
    if (this.errorReported) return
    const errors = this.serializeError(error)
    const currentUrl = window.location.href
    const params = {
      version: `v${Package.version}`,
      url_error: currentUrl,
      error_description: `ENV: ${process.env.NODE_ENV} \n MESSAGE: ${errors?.message} \n
      COMPONENT_STACK: ${errorInfo?.componentStack}`,
    }
    this.postError(params)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ef-root" role="alert" aria-live="assertive">
          <div className="ef-card">
            <div className="ef-badge">
              <span className="ef-badge-dot" />
              {!this.state.isLoading
                ? 'Incident signalé · équipe alertée'
                : 'Détection en cours…'}
            </div>

            <p className="ef-code" aria-hidden="true">
              {new Date().toLocaleTimeString('fr-FR')}
            </p>

            <h1 className="ef-title">Une erreur inattendue s'est produite</h1>

            <p className="ef-description">
              Cette page n'a pas pu s'afficher correctement. Ne vous inquiétez
              pas — l'incident a été automatiquement enregistré et transmis à
              l'équipe technique, qui le corrigera dans les plus brefs délais.
            </p>
            {this.state.isLoading ? (
              <LoaderWhiteBtn />
            ) : (
              <div className="ef-notice">
                <svg
                  className="ef-notice-icon"
                  viewBox="0 0 18 18"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M9 1.5A7.5 7.5 0 1 1 1.5 9 7.5 7.5 0 0 1 9 1.5Z"
                    stroke="currentColor"
                    strokeWidth="1.25"
                  />
                  <path
                    d="M9 8v4M9 6h.01"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>

                {this.state.isPosted ? (
                  <p className="ef-notice-text">
                    <strong>L'administrateur a été notifié</strong>
                    Un rapport d'incident complet a été envoyé automatiquement.
                    Vous n'avez aucune action à effectuer — l'erreur sera
                    corrigée bientôt.
                  </p>
                ) : (
                  <p className="ef-notice-text-error">
                    <strong>Une erreur est survenue</strong>
                    Nous n'avons pas pu envoyer le rapport d'incident
                    automatiquement. Veuillez contacter l'équipe support en
                    décrivant le problème rencontré.
                  </p>
                )}
              </div>
            )}
          </div>

          <p className="ef-footer">
            Si le problème persiste · contactez le support
          </p>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary

